import React from 'react';
import {PAYMENT_TYPE_CARD, PAYMENT_TYPE_POINTS} from "../constants";
import Select from 'react-select';

const PaymentMethodDropDown = ({
                        i18n,
                        paymentType,
                        hasPointsMethod,
                        hasCardsMethod,
                        paymentMethods,
                        onPaymentMethodChange,
                        selectedPaymentMethod
                    }) => {
    return (
        <div style={{ marginBottom: '1rem' }}>
            <h2 className="font-weight-bold">{i18n.t("payment_method_which")}</h2>
            <Select
                placeholder={paymentType === PAYMENT_TYPE_POINTS ? i18n.t("loyalty_program") : i18n.t("payment_method")}
                searchable={false}
                clearable={false}
                value={selectedPaymentMethod}
                onChange={item => onPaymentMethodChange(item)}
                options={paymentMethods.map(method => ({
                    value: method.id,
                    label: method.pointsCategory ? method.pointsCategory.name : method.name,
                    category: method.pointsCategory ? method.pointsCategory.id : null,
                    conversion: method.pointsCategory ? method.pointsCategory.conversion : null,
                    applepayEnabled: method.applepayEnabled
                }))}
            />
        </div>
    );
};

export default PaymentMethodDropDown;



// WEBPACK FOOTER //
// ./client/components/PaymentMethodDropDown.js